'use es6';

import UIMultiLevelDropdown from 'UIComponents/dropdown/UIMultiLevelDropdown';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSearchParamSingleSelect } from '../../hooks/searchParamHooks';
import Big from 'UIComponents/elements/Big';
import { FILTER_TYPES_OTHER } from '../../constants/TopFilterConstants';
import UsageTracker from '../../utils/UsageTracker';
import { CALYPSO, OBSIDIAN } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const UIMultiLevelDropdownContainer = styled.div.withConfig({
  displayName: "CatalogDropdownMenu__UIMultiLevelDropdownContainer",
  componentId: "sc-1k54wkk-0"
})(["width:'130px';span:nth-child(2){color:", ";}"], CALYPSO);
const CatalogDropdownMenu = ({
  categories,
  hsSoftwareCategories,
  buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.heading.tracks"
  }),
  buttonUse = 'tertiary-light'
}) => {
  const filterTypeCategories = FILTER_TYPES_OTHER.CATEGORIES;
  const filterTypeTools = FILTER_TYPES_OTHER.TOOLS;
  const [__, setCatalogFilter] = useSearchParamSingleSelect();
  const trackFilterSelect = (selectedOption, filterType) => {
    UsageTracker.track('catalogDropdownInteraction', {
      action: 'catalog-option-selected',
      value: selectedOption,
      key: filterType
    });
    UsageTracker.track('filterInteraction', {
      action: 'filter-selected',
      value: selectedOption,
      key: filterType,
      isDropdown: true
    });
  };
  const onClickOption = (selectedOption, filterType) => {
    setCatalogFilter(filterType, selectedOption);
    trackFilterSelect(selectedOption, filterType);
  };
  const renderOptionsHeading = title => {
    const optionsHeading = {
      style: {
        backgroundColor: 'white'
      },
      label: /*#__PURE__*/_jsx(Big, {
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.categories.${title}`
          })
        })
      })
    };
    return optionsHeading;
  };
  const renderSubCategories = (category, filterType) => {
    return category.map(cat => {
      return {
        value: `{{ ${cat} }}`,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.${filterType}.${cat}`
        }),
        onClick: () => {
          onClickOption(cat, filterType);
        }
      };
    }).toArray();
  };
  const renderCategoryOptions = (items, filterType) => {
    return items.map((category, index) => {
      return {
        'data-test-id': `option-${index}`,
        value: `{{ ${index} }}`,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: typeof category === 'object' ? `learningCenter.topFilters.${filterType}group.${index}` : `learningCenter.topFilters.${filterType}.${index}`
        }),
        onClick: typeof category === 'object' ? null : () => {
          onClickOption(index, filterType);
        },
        options: typeof category === 'object' ? renderSubCategories(category, filterType) : null,
        style: {
          paddingLeft: '40px'
        }
      };
    }).toArray();
  };
  const getGroupOptionsWithHeading = (filterType, groupHeading) => {
    const options = renderCategoryOptions(filterType === filterTypeCategories ? categories : hsSoftwareCategories, filterType);
    options.splice(0, 0, renderOptionsHeading(groupHeading));
    return options;
  };
  const renderCategories = () => {
    return getGroupOptionsWithHeading(filterTypeCategories, 'categories');
  };
  const renderSoftwareCategories = () => {
    return getGroupOptionsWithHeading(filterTypeTools, 'hubspotSoftware');
  };
  const renderOptions = () => {
    return [...renderCategories(), ...renderSoftwareCategories()];
  };
  const onDropdownOpen = () => {
    UsageTracker.track('catalogDropdownInteraction', {
      action: 'catalog-dropdown-opened'
    });
  };
  return /*#__PURE__*/_jsx(UIMultiLevelDropdownContainer, {
    children: /*#__PURE__*/_jsx(UIMultiLevelDropdown, {
      autoPlacement: false,
      buttonClassName: "catalog-filter",
      buttonText: buttonText,
      buttonUse: buttonUse,
      "data-test-id": 'catalog-dropdown-filter',
      dropdownClassName: "catalog-filter",
      minMenuWidth: 240,
      onOpenStart: onDropdownOpen,
      options: [renderOptions()],
      placement: 'bottom right',
      style: buttonUse === 'tertiary-light' ? {
        width: 'fit-content',
        fontSize: '16px',
        height: '60px',
        backgroundColor: 'white',
        color: OBSIDIAN
      } : {}
    })
  });
};
export default CatalogDropdownMenu;